"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewDelivery = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _PriceRange = require("./PriceRange");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Older component displaying new delivery switch inside of delivery options dialogue.
 * @obsolete Can be dropped later when flat selection UI is used in all markets.
 */
const NewDelivery = ({
  isPickUpAvailable,
  isAddHomeDeliveryAddressAllowed,
  lastDeliveryItemFee,
  lastDeliveryItemMethod,
  onCreateAddress,
  togglePickupPointsDialog
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NewDeliveryRoot, {
    children: [isPickUpAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.EditDeliveryOption, {
      role: "button",
      tabIndex: 0,
      onClick: togglePickupPointsDialog,
      onKeyDown: togglePickupPointsDialog,
      ...getTestIdProps(_models.TestId.FindPickupPoint),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.MapPin, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DeliveryOptionContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DeliveryOptionLabel, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "findPickUpPoint"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceRange.PriceRange, {
          isHomeDelivery: false,
          lastDeliveryItemFee: lastDeliveryItemFee,
          lastDeliveryItemMethod: lastDeliveryItemMethod
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddIcon, {})]
    }) : null, isAddHomeDeliveryAddressAllowed ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.EditDeliveryOption, {
      role: "button",
      tabIndex: 0,
      onClick: onCreateAddress,
      onKeyDown: onCreateAddress,
      ...getTestIdProps(_models.TestId.NewDelivery),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Home, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DeliveryOptionContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DeliveryOptionLabel, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "newDeliveryAddress"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceRange.PriceRange, {
          isHomeDelivery: true,
          lastDeliveryItemFee: lastDeliveryItemFee,
          lastDeliveryItemMethod: lastDeliveryItemMethod
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddIcon, {})]
    }) : null]
  });
};
exports.NewDelivery = NewDelivery;